import { PATH_SEPARATOR } from '../../../constants/separator';

/**
 * Replaces the segment at `depth` and drops everything below it, because a new choice at one
 * level invalidates the branch beneath it. Clearing the root yields null.
 */
export const buildNestedOptionPath = (
  path: string | null | undefined,
  depth: number,
  value: string | null,
): string | null => {
  const segments = path ? path.split(PATH_SEPARATOR) : [];
  const next = value
    ? [...segments.slice(0, depth), value]
    : segments.slice(0, depth);

  return next.length ? next.join(PATH_SEPARATOR) : null;
};
